import React from 'react';
import FeedbackTooltip from './FeedbackTooltip';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { SelectedFeedback } from '../../NPOFeedback/utils';
import { mergeClassNames } from 'shared/utils/mergeClassNames';
import { TrueImpactTooltip } from '../../ReportBuilder/Components/ImpactSummary/QuestionTextTooltip';
import { ResolvedFeedback, VerifyFeedback } from '../FeedbackProvider';

interface FeedbackProgressProps {
  selectedIndex: number | undefined;
  feedbackByQuestions: SelectedFeedback[];
  resolvedFeedback: ResolvedFeedback;
  verifyFeedback: VerifyFeedback;
  setSelectedIndex: React.Dispatch<React.SetStateAction<number | undefined>>;
}

const FeedbackProgress: React.FC<FeedbackProgressProps> = ({
  selectedIndex,
  resolvedFeedback,
  verifyFeedback,
  feedbackByQuestions,
  setSelectedIndex,
}) => {
  const total =
    resolvedFeedback.questionIds.length || verifyFeedback.questionIds.length;
  return (
    <>
      <TrueImpactText variant="heading-label" align="center" color="blackPure">
        Feedback Progress:{' '}
        <span className="normal-font">
          {total === feedbackByQuestions.length
            ? 'Completed'
            : `${total} of ${feedbackByQuestions.length}`}
        </span>
      </TrueImpactText>
      <div className="feedback-progress">
        {feedbackByQuestions.map((section, index) => {
          const question = section?.question;
          const questionId = question?.questionId;
          const resolved = Boolean(
            questionId && resolvedFeedback.questionsById[questionId],
          );
          const verified = questionId
            ? verifyFeedback.questionsById[questionId]
            : undefined;
          const className = mergeClassNames(
            'section-part',
            selectedIndex === index
              ? 'selected'
              : verified
              ? verified
              : resolved
              ? 'resolved'
              : 'unresolved',
          );
          return (
            <TrueImpactTooltip
              key={index}
              tooltipComponent={
                <FeedbackTooltip
                  index={index}
                  section={section}
                  isResolved={resolved || verified === 'verified'}
                  isRejected={verified === 'rejected'}
                />
              }
              className={className}
            >
              <div
                className={className}
                onClick={() => setSelectedIndex(index)}
              />
            </TrueImpactTooltip>
          );
        })}
      </div>
    </>
  );
};

export default FeedbackProgress;
